export { SuitabilityBadges } from './SuitabilityBadges';
